import { InfoboxesOptionsType } from "@/types/ModuleOptionsType";
import { customSanitize } from "../../../utils/customSanitize";
import { InfoBox } from "../InfoBoxes/InfoBox";
import { TextInfoBoxType } from "../InfoBoxesModule";

interface TextInfoBoxProps {
  text_infobox: TextInfoBoxType;
  columnsClass: string;
  fitHeight?: boolean;
  infoBoxOptions: InfoboxesOptionsType;
  extraClass?: string;
  show_cardbox: boolean;
  show_divider: boolean;
  heading_level: number;
}

export const TextInfoBox = ({
  text_infobox,
  columnsClass,
  // fitHeight = false,
  infoBoxOptions,
  extraClass,
  show_cardbox,
  show_divider,
  heading_level,
}: TextInfoBoxProps) => {
  const { title, content, infobox, link, link_extended, infobox_title } =
    text_infobox || {};

  const element = {
    infobox: infobox,
    link: link,
    link_extended: link_extended,
    title: infobox_title,
  };

  return (
    <div className={`columns ${columnsClass || ""}`}>
      <div className={`column is-6 ${extraClass}`}>
        <span
          className="title"
          dangerouslySetInnerHTML={{ __html: customSanitize(title) }}
        />
        <div
          dangerouslySetInnerHTML={{ __html: customSanitize(content) }}
        ></div>
      </div>
      <InfoBox
        extraClass={`${extraClass}`}
        element={element}
        infoBoxOptions={infoBoxOptions}
        show_cardbox={show_cardbox}
        show_divider={show_divider}
        heading_level={heading_level}
      />
    </div>
  );
};
